import { render, staticRenderFns } from "./RankingGeral.vue?vue&type=template&id=494e6186&"
import script from "./RankingGeral.vue?vue&type=script&lang=js&"
export * from "./RankingGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports